import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReCaptcha from 'react-google-recaptcha';

/**
 * A simple captcha to protect forms and other submissions from bots.
 * Can be displayed in two sizes and two themes.
 *
 * Sizes:
 *  normal: Standard rectangle captcha
 *  compact: Smaller form factor captcha
 * Themes:
 *  light: light theme
 *  dark: dark theme
 */
const Captcha = forwardRef(
    (
        { size = 'normal', theme = 'light', onVerify, onExpired, onError },
        ref
    ) => {
        const apiKey = process.env.REACT_APP_RECAPTCHA_API_KEY;

        return (
            <ReCaptcha
                ref={ref}
                sitekey={apiKey}
                size={size}
                theme={theme}
                onChange={onVerify}
                onExpired={onExpired}
                onError={onError}
            />
        );
    }
);
Captcha.displayName = 'Captcha';

/**
 * When using this component:
 *
 *  Frontend:
 *      define an onVerify function that sets the token
 *      define a size
 *      define a theme
 *      When sending data in API request, use the spread operator to include the token.
 *  Backend:
 *      In the routes.js for the related feature, include the verify-captcha middleware on the router.post request
 */

Captcha.propTypes = {
    size: PropTypes.oneOf(['normal', 'compact']),
    theme: PropTypes.oneOf(['light', 'dark']),
    onVerify: PropTypes.func.isRequired,
    onExpired: PropTypes.func,
    onError: PropTypes.func,
};

export default Captcha;
